import { fbButton } from 'vanilla-sharing'; //Facebook
import { tw } from 'vanilla-sharing'; // Twitter
import { email } from 'vanilla-sharing'; // Email
import { linkedin } from 'vanilla-sharing'; // Linkedin
import { whatsapp } from 'vanilla-sharing'; // Whatsapp
import { reddit } from 'vanilla-sharing'; // Reddit
import { pinterest } from 'vanilla-sharing'; // Pinterest
import { tumblr } from 'vanilla-sharing'; // Tumblr
import { telegram } from 'vanilla-sharing'; // Telegram
import { line } from 'vanilla-sharing'; // Line
import { isSet } from '../utils/isSet';
import { Dropdown } from './Dropdown';

class Share {
    constructor (root) {
        this.root = root;

        this.url = window.location.href;
        this.title = document.title;
        this.descriptionMetaElm = document.querySelector('meta[name="description"]');
        this.imageMetaElm = document.querySelector('meta[property="og:image"]');
        this.description = (isSet(this.descriptionMetaElm)) ? this.descriptionMetaElm.content : '';
        this.image = (isSet(this.image)) ? this.imageMetaElm.content : '';
        this.tags = ['MatthewAlgie', 'Coffee'];

        this.shareFacebookButtonElm = this.root.querySelector('#share__facebook');
        this.shareTwitterButtonElm = this.root.querySelector('#share__twitter');
        this.shareEmailButtonElm = this.root.querySelector('#share__email');
        this.shareLinkedinButtonElm = this.root.querySelector('#share__linkedin');
        this.shareWhatsappButtonElm = this.root.querySelector('#share__whatsapp');
        this.shareRedditButtonElm = this.root.querySelector('#share__reddit');
        this.sharePinterestButtonElm = this.root.querySelector('#share__pinterest');
        this.shareTumblrButtonElm = this.root.querySelector('#share__tumblr');
        this.shareTelegramButtonElm = this.root.querySelector('#share__telegram');
        this.shareLineButtonElm = this.root.querySelector('#share__line');
        
        this.init();
    }

    init(){
        this.init__dropdown();
        this.init__events();
        this.init__copy();
    }

    init__dropdown(){
        this.dropdownAPI = new Dropdown(
            this.root,
            {}
        )
    }

    init__events(){
        if(isSet(this.shareFacebookButtonElm)){
            this.shareFacebookButtonElm.addEventListener('click', () => {
                fbButton({
                    url: this.url
                });
            });
        }

        if(isSet(this.shareTwitterButtonElm)){
            this.shareTwitterButtonElm.addEventListener('click', () => {
                tw({
                    url: this.url,
                    title: this.title,
                    hashtags: this.tags
                });
            });
        }

        if(isSet(this.shareEmailButtonElm)){
            this.shareEmailButtonElm.addEventListener('click', () => {
                email({
                    url: this.url,
                    title: this.title,
                    subject: this.title,
                    description: this.description
                });
            });
        }

        if(isSet(this.shareLinkedinButtonElm)){
            this.shareLinkedinButtonElm.addEventListener('click', () => {
                linkedin({
                    url: this.url,
                    title: this.title,
                    description: this.description
                });
            });
        }

        if(isSet(this.shareWhatsappButtonElm)){
            this.shareWhatsappButtonElm.addEventListener('click', () => {
                whatsapp({
                    url: this.url,
                    title: this.title
                });
            });
        }

        if(isSet(this.shareRedditButtonElm)){
            this.shareRedditButtonElm.addEventListener('click', () => {
                reddit({
                    url: this.url,
                    title: this.title
                });
            });
        }

        if(isSet(this.sharePinterestButtonElm)){
            this.sharePinterestButtonElm.addEventListener('click', () => {
                pinterest({
                    url: this.url,
                    description: this.description,
                    media: this.image
                });
            });
        }

        if(isSet(this.shareTumblrButtonElm)){
            this.shareTumblrButtonElm.addEventListener('click', () => {
                tumblr({
                    url: this.url,
                    title: this.title,
                    caption: this.description,
                    tags: this.tags
                });
            });
        }

        if(isSet(this.shareTelegramButtonElm)){
            this.shareTelegramButtonElm.addEventListener('click', () => {
                telegram({
                    url: this.url,
                    title: this.title
                });
            });
        }

        if(isSet(this.shareLineButtonElm)){
            this.shareLineButtonElm.addEventListener('click', () => {
                line({
                    url: this.url,
                    title: this.title
                });
            });
        }
    }

    init__copy(){
        this.copyElm = this.root.querySelector('.share__copy');
        if(!isSet(this.copyElm)) return;
        this.copyInputElm = this.copyElm.querySelector('input');
        this.copyButtonElm = this.copyElm.querySelector('button');

        if(!isSet(this.copyInputElm) || !isSet(this.copyButtonElm)) return;

        this.copyInputElm.value = window.location.href;

        this.copyInputElm.addEventListener('focus', () => {
            this.copyInputElm.select();
        });


        this.onCopyInputClickBound = this.onCopyInputClick.bind(this)
        this.copyButtonElm.addEventListener(
            'click', 
            this.onCopyInputClickBound
        );
    }

    onCopyInputClick(){
        this.copyElm = this.root.querySelector('.share__copy');
        if(!isSet(this.copyElm)) return;
        this.copyInputElm = this.copyElm.querySelector('input');
        this.copyButtonElm = this.copyElm.querySelector('button');

        const copyContent = async () => {
            try {
                await navigator.clipboard.writeText(this.copyInputElm.value);
                this.copyButtonElm.querySelector('span').textContent = 'Copied!';
                this.copyButtonElm.querySelector('i').classList.remove('ma-icon--copy');
                this.copyButtonElm.querySelector('i').classList.add('ma-icon--check');

                setTimeout(() => {
                    this.copyButtonElm.querySelector('span').textContent = 'Copy Link';
                    this.copyButtonElm.querySelector('i').classList.remove('ma-icon--check');
                    this.copyButtonElm.querySelector('i').classList.add('ma-icon--copy');
                }, 2000);
                
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        }

        copyContent();
    }

}

export { Share }